module.exports = __webpack_public_path__ + "static/media/pop-close.89afd159.svg";